import { Component, OnInit } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Episode } from '../../models';
import { EcomicService } from '../../service/comics/ecomic.service';
declare const swal: any;
declare var $: any;

@Component({
  selector: 'app-wis-episodes',
  templateUrl: './wis-episodes.component.html',
  styleUrls: ['./wis-episodes.component.css']
})
export class WisEpisodesComponent implements OnInit {
  WISepisodecol: AngularFirestoreCollection<Episode>;
  WISepisodes: Observable<Episode[]>;
  showseries: any = true;
  WISseasons: any;
  seasonoption: any = 'All';
  selectedseason: any = 'All';
  selectedstatus: any = 'All';
  id:any;
  constructor(private afs: AngularFirestore, private comicService: EcomicService) { }

  async ngOnInit() {
    this.showseries = false;
    const collection = await this.afs.collection('WISSeason');
    await collection.valueChanges().subscribe(seriess => {
      this.WISseasons = seriess;
      this.showseries = true;
    });
    this.WISepisodecol = this.afs.collection('/WISEpisodes',res =>{
      return res.orderBy('createdAt', 'desc');
    });
    this.WISepisodes = this.WISepisodecol.valueChanges();
  }
  filterdata () {
    const type = this.selectedseason != 'All' ? 'season_id' : 'status';
    const content = this.selectedseason != 'All' ? this.selectedseason : this.selectedstatus;
    this.WISepisodecol = this.afs.collection('WISEpisodes', res => {
      if (this.selectedseason == 'All'  && this.selectedstatus == 'All') {
        return res.orderBy('createdAt', 'desc');
      } else if (this.selectedseason != 'All' && this.selectedstatus != 'All') {
        console.log('fine');
        return res.orderBy('createdAt', 'desc').where('status', '==', this.selectedstatus)
                  .where('season_id', '==', this.selectedseason);
      } else if (this.selectedstatus != 'All' && this.selectedseason == 'All'){
        return res.orderBy('createdAt', 'desc').where('status', '==', this.selectedstatus)
      }
      else if (this.selectedstatus == 'All' && this.selectedseason != 'All'){
        return res.orderBy('createdAt', 'desc').where('season_id', '==', this.selectedseason)
      }
      else {
        return res.orderBy('createdAt', 'desc').where(type, '==', content);
       }
    });
    this.WISepisodes = this.WISepisodecol.valueChanges();
  }
  delete(id) {
    console.log(id);
    this.id = id;
    $("#DeleteModal").modal();
  }
  deletedata() {
    $('#DeleteModal').modal('hide');
      this.afs.doc('/WISEpisodes/'+this.id).delete().then(function () {  
        swal('Deleted!', 'Your Episode has been deleted.', 'success');
      }).catch(function(error){
        swal('Error!', error, 'error');
        console.error("error in removing document:",error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/wis/wis-episodes/wis-episodes.component.ts